import { useState } from "react"
import { ToastMessage } from "../../../global/ToastMessage"
import { FChangePassStyle } from "./styles"
import { useFormik } from "formik"
import TextField from "@material-ui/core/TextField"
import { Button, Grid } from "@material-ui/core"
import { useDispatch } from "react-redux"
import { changePasswordAction } from "./../../../ducks/usuariosDuck"
import HeaderModal from "../../../global/headerModal"
import BackDrop from "./../../../global/BackDrop"
import ModalBase from "./../../../global/ModalBase"
import * as yup from "yup";
import { VisibilityOff, Visibility } from "@material-ui/icons"
import { IconButton, InputAdornment, Tooltip } from "@material-ui/core"
import VpnKeyIcon from '@material-ui/icons/VpnKey'
const validationSchema = yup.object({
    password: yup.string().required("Contraseña es requerido").min(8, "Minimo 8 caracteres"),
    confPassword: yup.string().oneOf([yup.ref('password'), null], 'Las contraseñas deben coincidir'),
})

const InitalValues = {
    password: "",
    confPassword: ""
};
const FChangePass = (props) => {
    const {
        open = true,
        setOpen = () => { },
        row = {},
    } = props
    const dispatch = useDispatch()
    const classes = FChangePassStyle()
    const [isLoad, setIsLoad] = useState(false)
    const [passShow, setPassShow] = useState(false)
    const [passcShow, setPasscShow] = useState(false)
    const handleClickShowPassword = () => {
        setPassShow(!passShow)
    }
    const handleClickShowPasswordC = () => {
        setPasscShow(!passcShow)
    }
    const formik = useFormik({
        initialValues: InitalValues,
        validationSchema: validationSchema,
        onSubmit: (values) => onSave(values),
    })

    const onSave = (values) => {
        setIsLoad(true)
        dispatch(changePasswordAction({ IdUser: row?.Id, PasswordHash: values.password, })).then((Response) => {
            switch (Response.status) {
                case 500:
                    ToastMessage.fire({
                        icon: "error",
                        title: "Ha habido un problema de conexión con el servidor",
                    })
                    break
                case 400:
                    ToastMessage.fire({
                        icon: "warning",
                        title: "<strong>Atención</strong>",
                        text: "Al menos un dato no se ha enviado, favor de llenar el registro.",
                    })
                    break
                default:
                    handleClose();
                    ToastMessage.fire({
                        icon: "success",
                        title: "Ingreso Correcto",
                    })
                    break
            }
            setIsLoad(false)
        })
    }

    const LimpiarForm = () => {
        formik.resetForm(InitalValues)
    }
    const handleClose = () => {
        setOpen(!open)
        LimpiarForm()
    }
    return (
        <ModalBase classes={classes} open={open} onClose={handleClose}>
            <HeaderModal
                handleClose={handleClose}
                titulo={"Cambiar contraseña"}
            />
            <form onSubmit={formik.handleSubmit}>
                <Grid container className={classes.containerSpacing}>
                    <Grid item xs={6}>
                        <TextField
                            required
                            id="input-password"
                            label="Contraseña"
                            type={passShow ? "text" : "password"}
                            variant="outlined"
                            name="password"
                            value={formik.values.password}
                            onChange={formik.handleChange}
                            error={formik.touched.password && Boolean(formik.errors.password)}
                            helperText={formik.touched.password && formik.errors.password}
                            className={classes.textField}
                            InputProps={{
                                endAdornment: <InputAdornment position="end">
                                    <IconButton
                                        aria-label="toggle password visibility"
                                        onClick={handleClickShowPassword}
                                        edge="end"
                                    >
                                        {passShow ? <Visibility /> : <VisibilityOff />}
                                    </IconButton>
                                </InputAdornment>,
                            }}
                        />
                    </Grid>
                    <Grid item xs={6}>
                        <TextField
                            required
                            id="input-conf-password"
                            label="Confirmar contraseña"
                            type={passcShow ? "text" : "password"}
                            variant="outlined"
                            name="confPassword"
                            value={formik.values.confPassword}
                            onChange={formik.handleChange}
                            error={formik.touched.confPassword && Boolean(formik.errors.confPassword)}
                            helperText={formik.touched.confPassword && formik.errors.confPassword}
                            className={classes.textField}
                            InputProps={{
                                endAdornment: <InputAdornment position="end">
                                    <IconButton
                                        aria-label="toggle password visibility"
                                        onClick={handleClickShowPasswordC}
                                        edge="end"
                                    >
                                        {passcShow ? <Visibility /> : <VisibilityOff />}
                                    </IconButton>
                                </InputAdornment>,
                            }}
                        />
                    </Grid>
                </Grid>
                <Grid container className={classes.containerSpacing}>
                    <Grid item xs={12} className={classes.modalBotonesCenter}>
                        <Button
                            type="submit"
                            variant="contained"
                            color="primary"
                            className={classes.modalBoton}
                        >
                            Guardar
                        </Button>
                    </Grid>
                </Grid>
                <BackDrop open={isLoad} />
            </form>
        </ModalBase>
    )
}
const ButtonResetPass = (props) => {
    const { row } = props
    const [open, setOpen] = useState(false)
    const handleClick = () => {
        setOpen(!open)
    }
    return (
        <div>
            <Tooltip title="Cambia contraseña">
                <IconButton aria-label="delete" onClick={handleClick}>
                    <VpnKeyIcon />
                </IconButton>
            </Tooltip>
            <FChangePass row={row} open={open} setOpen={setOpen} />
        </div>
    )
}
export default ButtonResetPass;
